<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="img"><img alt="image" src="images/129_1.jpg" style="height: auto; max-height: 100%; width: auto; max-width: 100%; margin:0px 0px 0px 0px; padding:0px 0px 0px 0px; border:0px;"/></p>
<h2 class="chaptersubtitle">CONTENTS</h2>
<p class="extra-indent"> </p>
<p class="extra-indent"> </p>
<p class="toc"><span href="#/ack" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
<p class="toc">CONTENTS</p>
<p class="toc"><a href="#/ford">FOREWORD</a></p>
<p class="extra-indent"> </p>
<p class="toc1"><a href="#/chap01">C<span class="small">HAPTER</span> 1  ~ Happy New Year</a></p>
<p class="toc1"><span href="#/chap02" title="Link target outside of Sample">C<span class="small">HAPTER</span> 2  ~ Jack's Lost Journey</span></p>
<p class="toc1"><span href="#/chap03" title="Link target outside of Sample">C<span class="small">HAPTER</span> 3  ~ Closer Than a Brother</span></p>
<p class="toc1"><span href="#/chap04" title="Link target outside of Sample">C<span class="small">HAPTER</span> 4  ~ A Bridge for a Beautiful Heart</span></p>
<p class="toc1"><span href="#/chap05" title="Link target outside of Sample">C<span class="small">HAPTER</span> 5  ~ The Song of My Life</span></p>
<p class="toc1"><span href="#/chap06" title="Link target outside of Sample">C<span class="small">HAPTER</span> 6  ~ Lacee's Story</span></p>
<p class="toc1"><span href="#/chap07" title="Link target outside of Sample">C<span class="small">HAPTER</span> 7  ~  Grace Runs Deep</span></p>
<p class="toc1"><span href="#/chap08" title="Link target outside of Sample">C<span class="small">HAPTER</span> 8  ~  Don't Let Being Good Keep You from Being Great</span></p>
<p class="toc1"><span href="#/chap09" title="Link target outside of Sample">C<span class="small">HAPTER</span> 9  ~  A Burning Hope</span></p>
<p class="toc1"><span href="#/chap10" title="Link target outside of Sample">C<span class="small">HAPTER</span> 10  ~  God's Poet</span></p>
<p class="toc1"><span href="#/chap11" title="Link target outside of Sample">C<span class="small">HAPTER</span> 11  ~  Escaping Pandora's Box</span></p>
<p class="toc1"><span href="#/chap12" title="Link target outside of Sample">C<span class="small">HAPTER</span> 12  ~  From A Broken Vessel To A Masterpiece</span></p>
<p class="extra-indent"> </p>
<p class="toc"><span href="#/epi" title="Link target outside of Sample">EPILOGUE</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?7b32ad1d